<template>
  <div v-if="reach" class="rounded bg-secondary-50 border border-secondary-200 px-5 py-4">
    <div class="flex items-start gap-3">
      <BaseIcon icon="users" class="text-secondary-500 mt-1" />
      <div class="flex-1">
        <div class="text-sm text-gray-800">
          <template v-if="reach.groups">{{ $t("securone.reach.reaches") }} {{ reachLine }}</template>
          <span v-else class="text-red-600">{{ $t("securone.reach.nobody") }}</span>
        </div>

        <!-- AR-S1: a Securdia account has no alarm reach and is offered no join action -->
        <div v-if="!reach.isPrincipal" class="text-xs text-gray-600 mt-1">{{ $t("securone.reach.securdia_not_recipient") }}</div>
        <div v-else-if="reach.includesMe" class="text-xs text-gray-600 mt-1">{{ $t("securone.reach.you_are_recipient") }}</div>
        <div v-else class="text-xs text-gray-600 mt-1">{{ $t("securone.reach.you_are_not_recipient") }}</div>

        <div v-if="reach.groupsDetail.length" class="flex flex-wrap gap-2 mt-2">
          <span v-for="g in reach.groupsDetail" :key="g._id" class="inline-flex items-center gap-2 rounded border border-secondary-300 bg-white px-2 py-0.5 text-xs text-gray-700">
            {{ g.name }} <span class="font-mono text-gray-400">{{ g.memberCount }}</span>
            <span v-if="g.isMember" class="text-secondary-700">{{ $t("securone.reach.member") }}</span>
            <!-- inline join (AR2: everybody joins like everybody else); absent for Securdia and for groups this actor may not edit -->
            <button v-else-if="g.canJoin" class="text-secondary-700 hover:underline" :disabled="busy" @click="join(g)">{{ $t("securone.reach.join") }}</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../securone.api";
import { errorMessage } from "../securone.helpers";

// T21: after saving a category, how many people it reaches through how many
// groups, whether the current user is one of them, and an inline action to
// join a linked group. Informational, never a modal, never a decision gate.
export default {
  name: "ReachPanel",
  props: {
    categoryId: { type: String, required: true },
  },
  data() {
    return { reach: null, busy: false };
  },
  computed: {
    reachLine() {
      let line = this.$tc("securone.common.people_in_groups", this.reach.groups, { people: this.reach.people, groups: this.reach.groups });
      if (this.reach.sms) line += " · " + this.$tc("securone.common.sms_contacts_count", this.reach.sms, { n: this.reach.sms });
      return line;
    },
  },
  methods: {
    async load() {
      try {
        this.reach = await api.categoryReach(this.categoryId);
      } catch (error) {
        this.reach = null;
      }
    },
    async join(group) {
      this.busy = true;
      try {
        const me = this.$store.getters["securone/me"];
        const full = (await api.groups()).find((g) => g._id === group._id);
        const members = Array.from(new Set([...(full ? full.members : []).map(String), String(me._id)]));
        await api.updateGroup(group._id, { members });
        await this.$store.dispatch("securone/loadContext", {});
        await this.load();
        this.$emit("joined", group);
      } catch (error) {
        this.handleError(error, errorMessage(this, error));
      } finally {
        this.busy = false;
      }
    },
  },
  watch: {
    categoryId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
};
</script>
